// export const BASE_URL = "https://mydb.5w1h.co.in:3000";
// export const BASE_URL = "http://localhost:8080";
// export const BASE_URL = "/api";
export const BASE_URL = "https://5w1h-api.vercel.app";
